import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLikeFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={0.857}
        d="M8 4.603c3.652-3.703 9.911 3.175 0 8.73C-1.911 7.778 4.348.9 8 4.603Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLikeFilled);
export default ForwardRef;
